import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from '@usas/ui-web/wrappers/ReactRouterDom';

import { ADD_VIEW_TYPE_ADDITIONAL_OFFERING, ADD_VIEW_TYPE_NEW_OFFERING } from '../../../utils/OfferingManagementConstants';

import useOfferingManagementInstanceOrgUnitData from '../../../../../state/offeringManagementInstanceOrgUnit/UseOfferingManagementInstanceOrgUnitData';

import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';

const INITIAL_STATE = {
  offeringInstanceObj: {},
  reportPeriodObj: {},
  orgUnitObj: {},
  viewType: null,
  pageErrorMessage: ''
};

const useLscOfferingInstanceOrgUnitAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { navRoutes } = useNavRoutes();
  const { selectOrgUnitState } = useSelectOrgUnitData();
  const { offeringManagementInstanceOrgUnitState, postOfferingInstanceOrgUnit } = useOfferingManagementInstanceOrgUnitData();
  const [state, setState] = useState(INITIAL_STATE);

  const onSubmitOfferingInstanceOrgUnitForm = (newOfferingInstanceOrgUnitObj) => {
    const postOfferingInstanceOrgUnitPromise = postOfferingInstanceOrgUnit(newOfferingInstanceOrgUnitObj);

    if (postOfferingInstanceOrgUnitPromise ?? false) {
      postOfferingInstanceOrgUnitPromise.then((newState) => {
        if (newState ?? false) {
          navigate(navRoutes.OFFERING_MANAGMENT_LSC_OFFERINGS?.route)
        }
      }).catch((e) => {
        setState({
          ...state,
          pageErrorMessage: e?.message || 'Failed to add offering'
        })
      });
    }
  };

  const onBackClicked = (e) => {
    e?.preventDefault();

    navigate(navRoutes.OFFERING_MANAGMENT_LSC_OFFERINGS?.route)
  }

  useEffect(() => {
    if (selectOrgUnitState.orgUnitId && selectOrgUnitState.orgUnitName
      && location.state?.reportPeriod) {
      let newState = {
        ...state,
        reportPeriodObj: location.state.reportPeriod,
        orgUnitObj: {
          orgUnitId: selectOrgUnitState.orgUnitId,
          orgUnitName: selectOrgUnitState.orgUnitName
        }
      };

      if (location.state?.offeringInstance) {
        setState({
          ...newState,
          offeringInstanceObj: location.state.offeringInstance,
          viewType: ADD_VIEW_TYPE_ADDITIONAL_OFFERING
        });
      } else {
        setState({
          ...newState,
          viewType: ADD_VIEW_TYPE_NEW_OFFERING
        });
      }
    } else {
      setState({
        ...state,
        pageErrorMessage: 'Failed to load report period and LSC'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isSaving: offeringManagementInstanceOrgUnitState.isObjLoading,
    state,
    onSubmitOfferingInstanceOrgUnitForm,
    onBackClicked
  };
};

export default useLscOfferingInstanceOrgUnitAdd;